import SelectFiles from './SelectFiles';

export default SelectFiles;
